export const data = {
    projects: [
        {
            id: "3",
            typeOfService: "Web Development",
            title: "Forex website ",
            image: '/images/celsi.PNG',
            tools: 'using Nextjs ',
            style: 'and styled responsive with BootStrap.',
            url: 'https://celsius-techedu.netlify.app'
        },
        // {
        //     id: "5",
        //     typeOfService: "Web Development",
        //     title: "Blog website",
        //     image: 'images/',
        //     tools: 'using Nextjs ',
        //     style: 'and styled responsive with SASS, Tailwind',
        //     url: 'https://danographi.netlify.app'
        // },
        // {
        //     id: "7",
        //     typeOfService: "Web Development",
        //     title: "Todo List App",
        //     image: 'images/',
        //     tools: 'using Javascript ',
        //     style: 'and styled responsive with Tailwind',
        //     url: 'https://stackodo.netlify.app'
        // },
    ],
    ecommerce: [
        {
            id: "1",
            scopedev: "I developed",
            typeOfService: "Web Development",
            title: "Betting website",
            image: '/images/MacbookLaptop.png',
            tools: 'using Reactjs, MongoDB, Nodejs',
            style: 'and styled responsive with Material UI.',
            url: 'https://maxisdraw.netlify.app',
            ghUrl: 'https://github.com/agedet'
        },
        // {
        //     id: "2",
        //     scopedev: "I developed",
        //     typeOfService: "Web Development",
        //     title: "e-commerce website",
        //     image: '/images/dreep.PNG',
        //     tools: 'using Nextjs, MongoDB, Cloudinary, react-hook-form ',
        //     style: 'and styled responsive with SASS.',
        //     url: 'https://dreepstore.vercel.app'
        // },
        // {
        //     id: "6",
        //     typeOfService: "Web Development",
        //     title: "Photography website",
        //     image: 'images/',
        //     tools: 'using Nextjs ',
        //     style: 'and styled responsive with SASS, Tailwind',
        //     url: 'https://danographi.netlify.app'
        // },
    ],
    portfolio: [
        {
            id: "4",
            scopedev: "I developed",
            typeOfService: "Web Development",
            title: "Portfolio website",
            image: '/images/AniekanEdet.png',
            tools: 'using Reactjs',
            style: 'and styled responsive with SASS.',
            url: 'https://aniekangedet.netlify.app'
        },
    ]
}